module.exports = __webpack_public_path__ + "static/media/cykelfritid.26059a78.jpeg";